import Modal from "react-bootstrap/Modal";
import Form from "react-bootstrap/Form";
import { useState } from "react";
import useAccessToken from "../../../hooks/useAccessToken";
import { useMsal } from "@azure/msal-react";
import Button from "react-bootstrap/Button";

const promptSuggestionHTMLTemplate = (email: string, type: string, usecase: string, suggestion: string) => {

    return `<h2>Prompt suggestion</h2>
            <h3>User:</h3> 
            <p>${email}.</p> 
            <h3>Type:</h3>
            <p>${type === "new" ? "New prompt" : "Modification of an existing prompt"}</p>
            <h3>Usecase:</h3>
            <p>${usecase}</p>
            <h3>Suggestion:</h3>
            <p>${suggestion}</p>`;
}


const SendPromptSuggModal = ({show, handleClose}: {show: boolean, handleClose: () => void}) => {

    const [type, setType] = useState("new"); //New prompt or modify
    const [suggestion, setSuggestion] = useState("");
    const [usecase, setUsecase] = useState("");
    const { accounts } = useMsal();
    const accessToken = useAccessToken();
    const [isSent, setIsSent] = useState(false);

    const email = accounts[0]?.username;

    const closeModal = () => {
        setIsSent(false);
        setUsecase("");
        setSuggestion("");
        setType("new");
        handleClose();
    }

    const sendEmail = async () => {

        const subject = "Prompt suggestion";
        const body = promptSuggestionHTMLTemplate(email, type, usecase, suggestion);

        const emailData = {
            message: {
                subject: subject,
                body: {
                    contentType: "HTML",
                    content: body,
                },
                toRecipients: [
                    {
                        emailAddress: {
                            address: "georges@infraviacapital.com",
                        },
                    },
                ],
            },
        };
    
        const response = await fetch("https://graph.microsoft.com/v1.0/me/sendMail", {
            method: "POST",
            headers: {
                Authorization: `Bearer ${accessToken}`,
                "Content-Type": "application/json",
            },
            body: JSON.stringify(emailData),
        });
    
        if (response.ok) {
            console.log("Email sent successfully!");
            setIsSent(true);
        } else {
            console.error("Failed to send email", await response.text());
        }
    };
    

    return (
        <Modal show={show} onHide={handleClose} size="lg">
            <Modal.Header>
                <h5>Send a suggestion to Georges</h5>
            </Modal.Header>
            <Modal.Body style={{fontSize: 14}}>
                {isSent ? (
                    <>
                        <div>
                            <h5>Email sent successfully!</h5>
                        </div>
                        <Button variant="primary" onClick={closeModal}>Close</Button>
                    </>
                ) : (
                <Form>
                    <Form.Group className="mb-3">
                        <h6 style={{marginTop: 10}}>Suggestion Type</h6>
                        <Form.Check type="radio" label="Create a new prompt" value="new" checked={type === "new"} onChange={(e) => setType(e.target.value)} />
                        <Form.Check type="radio" label="Modify an existing prompt" value="modify" checked={type === "modify"} onChange={(e) => setType(e.target.value)} />
                        <h6 style={{marginTop: 10}}>Usecase</h6>
                        <Form.Control size="sm" type="text" placeholder="Describe your use-case" as="textarea" rows={5} value={usecase} onChange={(e) => setUsecase(e.target.value)} />
                        <h6 style={{marginTop: 10}}>Prompt Description</h6>
                        <Form.Control size="sm" type="text" placeholder="Describe your prompt suggestion" as="textarea" rows={5} value={suggestion} onChange={(e) => setSuggestion(e.target.value)} />
                    </Form.Group>
                    <Button variant="primary" onClick={sendEmail}>Send</Button>
                    <Button variant="secondary" onClick={closeModal} style={{marginLeft: 10}}>Cancel</Button>
                </Form>
                )}
                
            </Modal.Body>
        </Modal>
    )
}

export default SendPromptSuggModal;
